import { render, staticRenderFns } from "./DangerousFieldsBanner.vue?vue&type=template&id=57b71f7a&scoped=true&"
import script from "./DangerousFieldsBanner.vue?vue&type=script&lang=js&"
export * from "./DangerousFieldsBanner.vue?vue&type=script&lang=js&"
import style0 from "./DangerousFieldsBanner.vue?vue&type=style&index=0&id=57b71f7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b71f7a",
  null
  
)

export default component.exports